import { isPainelCodigoValido } from '../utils/painel-state.mjs'

const routes = [
  {
    path: '/',
    redirect: '/painel'
  },
  {
    name: 'painel-configuracao',
    path: '/painel',
    component: () => import('../components/PainelSetup.vue')
  },
  {
    name: 'painel',
    path: '/painel/:painel',
    component: () => import('../components/Main.vue'),
    beforeEnter(to, from, next) {
      if (isPainelCodigoValido(to.params.painel)) return next()
      next({
        name: 'painel-configuracao',
        query: { codigoInvalido: String(to.params.painel || '') }
      })
    },
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'prontuario',
    path: '/prontuario/:prontuario_codigo/:tipo',
    component: () => import('../pages/Prontuario.vue'),
    meta: {
      requiresAuth: false
    }
  }
]

export default routes
